import API_URLS from '../../API_URLS.json'

export default {
    install(Vue) {
        return Vue.prototype.$url = API_URLS
    }
}